import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Store} from "../../../../../services/store.service";
import {BaseError} from "../../../base-error";

@Component({
  selector: "determinant-form",
  templateUrl: "./determinant-form.component.html",
  providers: [],
})
export class DeterminantFormComponent extends BaseError {
  public listToggle: boolean = false;
  @Input() public serviceId: string;
  @Input() public form;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Output() public editCancel = new EventEmitter();
  @Output() public saveForm = new EventEmitter();

  constructor(private route: ActivatedRoute,
              public store: Store,
              toastr: ToastrService) {
    super(toastr);
  }

  public updateForm() {
    this.closeLayer();
    this.saveForm.emit();
  }

  public change(event) {
    this.form.jsonDeterminants = event.jsonString;
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeLayer() {
    this.editCancel.emit({cancel: true});
  }

  public setListView(b) {
    this.listToggle = b;
  }

  public getJsonString() {
    if (typeof this.form.jsonDeterminants === "string") {
      return this.form.jsonDeterminants;
    }
    return JSON.stringify(this.form.jsonDeterminants);
  }
}
